import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import {mapActions, mapState} from 'vuex'

export default {
  data () {
    return {
      isClickSearch: true,
      customerInfo: '',
      pageSize: 5,
      pageNum: 1
    }
  },
  computed: {
    ...mapState('cardOperationModule', ['searchMemberResult']),
    memberResult () {
      return this.searchMemberResult
    }
  },
  methods: {
    ...mapActions('cardOperationModule', ['getMembersByPage']),
    searchCustomer () {
      this.isClickSearch = false
      const pageData = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        allInfo: this.customerInfo
      }
      this.getMembersByPage(pageData)
    },
    skipToCouponOperation (item) {
      this.$router.push({
        path: RoutePathConstants.GRANT_OF_COUPON,
        query: {
          memberId: item.memberId,
          carId: item.id,
          vehicleName: item.vehicleName,
          carNumber: item.carNumber
        }
      })
    },
    getMemberByPage () {
      this.pageSize += 5
      this.searchCustomer()
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/card-operation/views/card-operation-search.js